module.exports = __webpack_public_path__ + "static/media/17.ede1acf9.png";